import React, { useState, useRef } from "react";
import axios from "axios";
import { FaRegImage } from "react-icons/fa";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Switch } from "antd";
import { useHistory } from "react-router-dom";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { CiLock } from "react-icons/ci";

const Profile = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [id, setId] = useState("");
    const [showPass, setShowPass] = useState("");

    const [role, setRole] = useState("");
    const [block, setBlock] = useState(false);
    const [pd, setPd] = useState("")
    const [imageChange, setImageChange] = useState(false);
    const fileInputRef = useRef(null);




    const [formData, setFormData] = useState({
        title: "",
        firstname: "",
        lastname: "",
        name: "",
        practitionerSpecialty: "",
        practitionerGroup: "",
        primaryPracticeName: "",
        registrationNumber: "",
        street: "",
        jobTitle: "",
        postcode: "",
        landline: "",
        email: "",
        townCity: "",
        password: "",
        statusId: "",
        secretaryName: "",
        secretaryTelephone: "",
        secretaryEmail: "",

        image: null,

    });


    useEffect(() => {
        const id = JSON.parse(sessionStorage.getItem("data"))?.userData._id;
        const sessionPassword = sessionStorage.getItem("password");

        /*        const sessionPassword = JSON.parse(sessionStorage.getItem("password"));
         */
        console.log(sessionPassword)
        setPd(sessionPassword);




        console.log(id);
        axios.get(`/users/${id}`).then((response) => {
            const userData = response.data?.data;
            console.log("response", userData.statusId);
            console.log(response)

            const status = JSON.parse(sessionStorage.getItem("data"))?.userData
                .statusId;
            const name = userData.name;
            console.log(name);

            if (userData.statusId === "inactive") {
                navigate("/");
                setTimeout(() => {
                    toast(
                        `Dear ${name} your is inactive. Please contact support for assistance`
                    );
                }, 500);
                return; // Exit the function after navigation
            }
        });
        if (state) {
            if (state?.consultant.statusId === "inactive") {
                setBlock(true)
            }
            setFormData({ ...state?.consultant, });
            setId(state?.consultant?._id);

        } else {

            const userId = JSON.parse(sessionStorage.getItem("data"))?.userData
                ?._id;
            const role = JSON.parse(sessionStorage.getItem("data"))?.userData
                ?.role;
            setRole(role);
            setId(userId);

            if (userId) {
                console.log("first")
                axios
                    .get(`/users/${userId}`)
                    .then((response) => {
                        const userData = response.data?.data;
                        console.log("response", userData.statusId);

                        setFormData({ ...userData, password: `${pd}` });
                    })
                    .catch((error) => {
                        console.error("Error fetching user data:", error);
                    });
            }
        }
        return () => {
            setImageChange(false);
        };
    }, []);
    console.log("cccc", formData.password)


    const toogler = () => {
        setBlock((prevBlock) => {
            setFormData((prevData) => ({
                ...prevData,
                statusId: !prevBlock ? "inactive" : "active", // Set the statusId based on the toggle
            }));
            return !prevBlock;
        });
        if (formData.statusId == "inactive") {
            toast(`Please confirm the unblocking of ${formData.title} ${formData.firstname} ${formData.lastname} by clicking the Save button.`)
        } else {
            toast(`Please confirm the blocking of ${formData.title} ${formData.firstname} ${formData.lastname} by clicking the Save button.`)
        }

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleImageChange = (event) => {
        const selectedImage = event.target.files[0];
        setFormData({
            ...formData,
            image: selectedImage,
        });
        setImageChange(true);
    };
    const handleRemoveImage = () => {
        setFormData({
            ...formData,
            image: null,
        });
        setImageChange(false);
    };
    const handleClickImage = () => {
        // Trigger the file input click event
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    const handleSubmit = async () => {
        const role = JSON.parse(sessionStorage.getItem("data"))?.userData
            ?.role;

        if (role === "consultant") {
            if (formData?.password === "" || formData?.password === undefined) {
                toast("Please fill out all required fields to continue");
                return true;
            } else if (formData.password.length < 8) {
                toast("Password should not be less than 8 characters");
                return true;
            }
        }



        if (formData?.title === "" || formData?.title === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.firstname === "" || formData?.firstname === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.jobTitle === "" || formData?.jobTitle === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.lastname === "" || formData?.lastname === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.email === "" || formData?.email === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.registrationNumber === "" || formData?.registrationNumber === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.secretaryEmail === "" || formData?.secretaryEmail === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.secretaryTelephone === "" || formData?.secretaryTelephone === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        }
        if (formData?.secretaryName === "" || formData?.secretaryName === undefined) {
            toast("Please fill out all required fields to continue");
            return true;
        } else {
            /* let Data = {
                ...formData,
                name: `${formData.title} ${formData.firstname} ${formData.lastname}`,
            }; */


            let formData1;
            formData1 = {
                title: formData.title,
                firstname: formData.firstname,
                lastname: formData.lastname,
                name: formData.name,
                practitionerSpecialty: formData.practitionerSpecialty,
                practitionerGroup: formData.practitionerGroup,
                primaryPracticeName: formData.primaryPracticeName,
                registrationNumber: formData.registrationNumber,
                street: formData.street,
                jobTitle: formData.jobTitle,
                postcode: formData.postcode,
                landline: formData.landline,
                password: formData.password,
                email: formData.email,
                townCity: formData.townCity,
                statusId: formData.statusId,
                secretaryName: formData.secretaryName,
                secretaryTelephone: formData.secretaryTelephone,
                secretaryEmail: formData.secretaryEmail,

                image: formData.image,
                check: true

            }


            let Data;

            if (formData.title === "Prefer Not to Say") {
                Data = {
                    ...formData,
                    name: `${formData.firstname} ${formData.lastname}`,
                    check: false
                };
            } else {
                Data = {
                    ...formData,
                    name: `${formData.title} ${formData.firstname} ${formData.lastname}`,
                    check: false
                };
            }

            console.log("Data", Data)

            let Data1;
            if (formData1.title === "Prefer Not to Say") {
                Data1 = {
                    ...formData1,
                    name: `${formData1.firstname} ${formData1.lastname}`,
                };
            } else {
                Data1 = {
                    ...formData1,
                    name: `${formData1.title} ${formData1.firstname} ${formData1.lastname}`,
                };
            }
            console.log("Data1", Data1)

            try {

                console.log("Data2", Data)
                if (role === "consultant") {


                    if (pd === formData.password) {
                        const response = await axios.patch(`/users/${id}`, Data, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        console.log("Data", response)
                        if (response?.status === 200 || response?.status === 201) {
                            const token = JSON.parse(sessionStorage.getItem("data"))
                                ?.userData?._id;
                            const data = response?.data?.data?.userData;
                            const userData = {
                                userData: data,
                                token,
                            };

                            // sessionStorage.setItem("data", JSON.stringify(userData));
                            toast.success(response.data.message);

                            if (response.data.data.role === "consultant") {
                                window.location.href = "/consultants";
                            } else {
                                window.location.href = "/consultants";

                            }
                            if (!state) {
                                console.log(response.data.data.role)
                                if (response.data.data.role === "consultant") {
                                    window.location.reload();

                                    window.location.href = "/welcome";
                                } else {
                                    window.location.reload();
                                    window.location.href = "/consultants";

                                }

                            }

                        } else {
                            toast("Something Went wrong, Please Try again");
                        }
                    } else {
                        toast.error("Input password is wrong")
                    }

                } else {
                    console.log(Data1)
                    const response = await axios.patch(`/users/${id}`, Data1, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    console.log("Data1", response)
                    if (response?.status === 200 || response?.status === 201) {
                        const token = JSON.parse(sessionStorage.getItem("data"))
                            ?.userData?._id;
                        const data = response?.data?.data?.userData;
                        const userData = {
                            userData: data,
                            token,
                        };

                        // sessionStorage.setItem("data", JSON.stringify(userData));
                        toast.success(response.data.message);

                        if (response.data.data.role === "consultant") {
                            window.location.href = "/consultants";
                        } else {
                            window.location.href = "/consultants";

                        }
                        if (!state) {
                            console.log(response.data.data.role)
                            if (response.data.data.role === "consultant") {
                                window.location.reload();

                                window.location.href = "/welcome";
                            } else {
                                window.location.reload();
                                window.location.href = "/consultants";

                            }

                        }

                    } else {
                        toast("Something Went wrong, Please Try again");
                    }

                }


            } catch (error) {
                console.error("Error saving profile:", error);
                toast.error(error.response.data.message);

            }
        }
    };

    return (
        <>
            {
                window.innerWidth < 500 ? (
                    <div className="text-center text-white p-4 bg-red-500">
                        Sorry! this portal is only operatable through desktop devices.
                    </div>
                ) : (
                    <div className="max-w-4xl ms-14 mt-10">
                        <div className="max-w-4xl ms-14 mt-10">
                            <ToastContainer />
                            <h2 className="mx-auto text-center text-3xl font-bold">
                                My Profile
                            </h2>
                            <div className="w-4/5 my-3 mx-auto flex justify-center text-center">
                                {role === "Admin" ? (
                                    <p>
                                        Some additional information is required for you to
                                        refer patients to us online.<br /><span className="text-black">Please fill out all required fields below to be able to make a patient referral immediately.</span>
                                    </p>
                                ) : (
                                    <>
                                        <p className="">
                                            Some additional information is required for you to
                                            refer patients to us online. <br /><span className="text-black">Please fill out all required fields below to be able to make a patient referral immediately.</span>
                                        </p>
                                    </>
                                )}
                            </div>
                            <form className="grid grid-cols-1 md:grid-cols-3 gap-10">
                                {/* First Column */}
                                <div>
                                    {/* {role !== "Admin" && (
            <input
              type="text"
              placeholder="Name"
              style={{ marginLeft: "1rem" }}
              className="py-2 border rounded-lg my-3 px-4 w-full"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
          )} */}
                                    {/* <div>
            <div style={{ position: "relative" }}>
              <span
                className="text-red-500"
                style={{ position: "absolute", top: "-0.1rem", right: "16rem" }}
              >
                *
              </span>
              <input
                type="text"
                placeholder="Name"
                style={{ marginLeft: "1rem" }}
                className="py-2 border rounded-lg my-3 px-4 w-full"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </div>
          </div> */}
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500 ml-2"
                                            style={{
                                                position: "absolute",
                                                top: "",
                                                right: "",
                                            }}
                                        >
                                            *
                                        </span>
                                        <select
                                            name="title"
                                            value={formData.title || ""}
                                            onChange={handleInputChange}
                                            placeholder="Select Title"
                                            className=" py-2 my-3 px-4 w-full rounded-lg border rounded-md bg-transparent focus:border-sky-blue-700 focus:outline-sky-blue-700 shadow"
                                            style={{ marginLeft: "1rem" }}
                                        >
                                            <option value="" disabled>
                                                Title
                                            </option>
                                            <option value="Mr">Mr</option>
                                            <option value="Miss">Miss</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Ms">Ms</option>
                                            <option value="Dr">Dr</option>
                                            <option value="Prof">Prof</option>
                                            <option value="Dame">Dame</option>
                                            <option value="Lady">Lady</option>
                                            <option value="Lord">Lord</option>
                                            <option value="Sir">Sir</option>


                                            <option value="Prefer Not to Say">
                                                Prefer Not to Say
                                            </option>
                                        </select>
                                    </div>

                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500 ml-2"
                                            style={{
                                                position: "absolute",
                                                top: "",
                                                right: "",
                                            }}
                                        >
                                            *
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="First Name"
                                            style={{ marginLeft: "1rem" }}
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            name="firstname"
                                            value={formData.firstname}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <span
                                        className="text-red-500"
                                        style={{
                                            position: "absolute",
                                            top: "-0.1rem",
                                            right: "16rem",
                                        }}
                                    >
                                        *
                                    </span>
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500 ml-2"
                                            style={{
                                                position: "absolute",
                                                top: "",
                                                right: "",
                                            }}
                                        >
                                            *
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Last Name"
                                            style={{ marginLeft: "1rem" }}
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            name="lastname"
                                            value={formData.lastname}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500 ml-2"
                                            style={{
                                                position: "absolute",
                                                top: "",
                                                right: "",
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>

                                    <input
                                        type="text"
                                        placeholder="Job Title"
                                        ssss
                                        style={{ marginLeft: "1rem" }}
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="jobTitle"
                                        value={formData.jobTitle}
                                        onChange={handleInputChange}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Postcode"
                                        style={{ marginLeft: "1rem" }}
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="postcode"
                                        value={formData.postcode}
                                        onChange={handleInputChange}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Referrer's mobile"
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="landline"
                                        style={{ marginLeft: "1rem" }}
                                        value={formData.landline}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* Second Column */}
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Primary Practice Name"
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="primaryPracticeName"
                                        value={formData.primaryPracticeName}
                                        onChange={handleInputChange}
                                    />
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500"
                                            style={{
                                                position: "absolute",
                                                top: "",  // You can set the desired top position
                                                left: "-7px",  // Adjust the value to move it to the right
                                            }}
                                        >
                                            *
                                        </span>


                                        <input
                                            type="text"
                                            placeholder="GMC/AHP Registration Number"
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            name="registrationNumber"
                                            value={formData.registrationNumber}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Street"
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="street"
                                        value={formData.street}
                                        onChange={handleInputChange}
                                    />
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500"
                                            style={{
                                                position: "absolute",
                                                top: "",  // You can set the desired top position
                                                left: "-7px",  // Adjust the value to move it to the right
                                            }}
                                        >
                                            *
                                        </span>
                                        <input
                                            type="email"
                                            placeholder="Referrer's email"
                                            name="email"
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevents the default behavior (opening mailto link)
                                                if (formData.email) {
                                                    // Handle any other click logic specific to the input
                                                }
                                            }}
                                        />

                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Town/City"
                                        className="py-2 border rounded-lg my-3 px-4 w-full"
                                        name="townCity"
                                        value={formData.townCity}
                                        onChange={handleInputChange}
                                    />
                                    <div style={{ position: "relative" }}>
                                        {role === "consultant" && (
                                            <span
                                                className="text-red-500"
                                                style={{
                                                    position: "absolute",
                                                    top: "",  // You can set the desired top position
                                                    left: "-7px",  // Adjust the value to move it to the right
                                                }}
                                            >
                                                *
                                            </span>
                                        )}

                                        {role === "consultant" && (
                                            <>
                                                {showPass ? (
                                                    <FaEyeSlash
                                                        className=" absolute right-1 w-6 h-6 mr-2 mt-5 text-gray-400 hover:shake"
                                                        onClick={() => setShowPass(!showPass)}
                                                    />
                                                ) : (
                                                    <FaEye
                                                        className=" absolute right-1 w-6 h-6 mr-2 mt-5 text-gray-400 hover:shake"
                                                        onClick={() => setShowPass(!showPass)}
                                                    />
                                                )}

                                                <input
                                                    type={showPass ? "text" : "password"}
                                                    placeholder="Password"
                                                    value={formData.password}
                                                    name="password"
                                                    className="py-2  border rounded-lg my-3 px-4 w-full"
                                                    onChange={handleInputChange}
                                                />
                                            </>
                                        )}
                                    </div>

                                </div>

                                {/* Third Column */}

                                <div className="flex flex-col items-center justify-start">
                                    {/* <p>Click below to update image</p> */}
                                    <label
                                        htmlFor="image"
                                        className={`inline cursor-pointer mt-4 ${imageChange ? 'hidden' : 'bg-[#2CA1C8]'
                                            }`}
                                        style={{ background: '#2CA1C8', color: 'white' }}
                                        onClick={handleClickImage}
                                    >
                                        {/* Your SVG Icon */}
                                    </label>
                                    <input
                                        type="file"
                                        id="image"
                                        name="image"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="hidden"
                                        ref={fileInputRef}
                                    />

                                    <p className="flex text-center font-bold text-[16px] mt-[-10px]">Click on the icon below to
                                        update your profile photo:</p>
                                    <div className="flex justify-start">
                                        {formData.image && !imageChange ? (
                                            <div
                                                className="mt-3 mb-4 max-w-full max-w-full w-[75px] h-[75px] rounded-full"
                                                style={{ borderRadius: '100%', width: '75px', height: '75px', marginBottom: '30px' }}
                                                onClick={handleClickImage}
                                            >
                                                <img
                                                    src={formData?.image}
                                                    alt="Selected"
                                                    className="rounded-full mt-3 max-w-full max-h-full h-auto w-[75px] h-[75px]"
                                                    style={{ borderRadius: '100%', width: '75px', height: '75px', marginBottom: '30px' }}
                                                />
                                            </div>
                                        ) : imageChange ? (
                                            <div className="">
                                                <img
                                                    src={URL.createObjectURL(formData?.image)}
                                                    alt="Selected"
                                                    className="mt-4 max-w-full h-auto w-[75px] h-[75px]"
                                                    style={{ borderRadius: '50px', cursor: 'pointer', width: '75px', height: '75px' }}
                                                    onClick={handleClickImage}
                                                />
                                                {/* <button onClick={handleRemoveImage}>Remove Image</button> */}
                                            </div>
                                        ) : null}
                                    </div>


                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500"
                                            style={{
                                                position: "absolute",
                                                top: "-13px",  // You can set the desired top position
                                                left: "10px",  // Adjust the value to move it to the right
                                            }}
                                        >
                                            *
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Secretary Name"
                                            style={{ marginLeft: "1rem" }}
                                            className="py-2 border rounded-lg mb-3 px-4 w-full"
                                            name="secretaryName"
                                            value={formData.secretaryName}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500"
                                            style={{
                                                position: "absolute",
                                                top: "",  // You can set the desired top position
                                                left: "10px",  // Adjust the value to move it to the right
                                            }}
                                        >
                                            *
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Secretary Telephone"
                                            style={{ marginLeft: "1rem" }}
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            name="secretaryTelephone"
                                            value={formData.secretaryTelephone}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div style={{ position: "relative" }}>
                                        <span
                                            className="text-red-500"
                                            style={{
                                                position: "absolute",
                                                top: "",  // You can set the desired top position
                                                left: "10px",  // Adjust the value to move it to the right
                                            }}
                                        >
                                            *
                                        </span>

                                        <input
                                            type="email"
                                            placeholder="Secretary Email"
                                            style={{ marginLeft: "1rem" }}
                                            className="py-2 border rounded-lg my-3 px-4 w-full"
                                            name="secretaryEmail"
                                            value={formData.secretaryEmail}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="flex mt-3 mr-3">

                                        {role !== "consultant" && (

                                            <>

                                                {formData.statusId === "inactive" ? <h2 className="font-bold text-[16px]">Unblock</h2> : <h2 className="font-bold text-[16px]">Block</h2>}
                                                {/*                                                 <h2 className="font-bold text-[16px]">Block</h2>
 */}                                                < Switch
                                                    checked={block}
                                                    className={`ml-2  ${block ? '' : 'switch-off'}`}
                                                    onChange={toogler}
                                                    style={{ backgroundColor: block ? 'LightSkyBlue' : 'gray' }}
                                                />
                                            </>
                                        )}

                                    </div>
                                    {/* <Switch className="mt-3" onClick={toogler} /> */}
                                </div>
                            </form>

                            {/* Submit Button */}
                            <div className="flex justify-end mt-4 md:mr-24">
                                <button
                                    onClick={handleSubmit}
                                    className="bg-[#003942] text-white px-4 py-2 rounded-md" style={{ marginBottom: "50px" }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default Profile;
